import {FormControl, InputLabel, Select, MenuItem} from '@mui/material/';
import styled from "@emotion/styled";
import { ChangeEvent, memo, useState } from 'react';
import { useRecoilState } from 'recoil';
import { tableNumberState } from '../../store/tableNumberState';

export const TableNumberInput = memo(() => {
    // 飲み会名の状態を管理
    const [tableNumber, setTableNumber] = useRecoilState(tableNumberState);

    const handleChange = (event:any) => {
        const value = event.target.value;
        setTableNumber(value);
      };

    return (
        <SInputContainer>
            <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">机の数</InputLabel>
            <Select
                labelId="tableNumberLabel"
                id="tableNumber"
                label="tableNumber"
                value={tableNumber}
                onChange={handleChange}
            >
            <MenuItem value={1}>1つ</MenuItem>
            <MenuItem value={2}>2つ</MenuItem>
            <MenuItem value={3}>3つ</MenuItem>
            <MenuItem value={4}>4つ</MenuItem>
            </Select>
            </FormControl>
        </SInputContainer>
    );
});

const SInputContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 10px;
    width: 100%;
`;
